
import ApprovalActions from "@/features/shared/components/sections/ApprovalActions.vue";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import Component from "vue-class-component";
import SectionDocumentMetaData from "@/features/shared/components/sections/SectionDocumentMetaData.vue";
import {
    factory,
    IQualificationActions, QualificationActions,
    QualificationsClient, TrainingQualificationDetailsModel,
    ValidityStatus
} from "@/api-client";
import {QualificationDetailsBase} from "@/features/documents/qualifications/views/QualificationDetailsBase";
import TrainingQualificationDetailsContent
    from "@/features/documents/qualifications/views/TrainingQualificationDetailsContent.vue";
import ValidityStatusBadge from "@/features/shared/components/ValidityStatusBadge.vue";
import Files from "@/components/Files.vue";
import RejectionDetails from "@/features/shared/components/RejectionDetails.vue";
import {Prop} from "vue-property-decorator";
import {NavigationGuardNext} from "vue-router/types/router";
import DetailsLayout from "@/features/personProfile/components/DetailsLayout.vue";
import BaseDocumentApplicationUsageWidget from "@/features/documents/components/BaseDocumentApplicationUsageWidget.vue";
import ButtonWithConfirm from "@/features/shared/components/ButtonWithConfirm.vue";
import toasts from "@/components/Toasts";
import Badge from "@/features/shared/components/Badge.vue";

interface Props {
    preloadedDetails: TrainingQualificationDetailsModel;
}

@Component({
    components: {
        ApprovalActions,
        SectionPageHeading,
        SectionDocumentMetaData,
        TrainingQualificationDetailsContent,
        ValidityStatusBadge,
        Files,
        RejectionDetails,
        DetailsLayout,
        BaseDocumentApplicationUsageWidget,
        ButtonWithConfirm,
        Badge
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<TrainingQualificationDetails>) {
        const props = to.meta!.props as Props;
        to.meta!.props.id = to.params.qualificationId || to.params.id;
        Promise.all([
            new QualificationsClient().getTrainingQualification(to.meta!.props.id)
        ]).then(values => {
            props.preloadedDetails = values[0];
            next();
        }).catch(e => next(e))
    }
})
export default class TrainingQualificationDetails extends QualificationDetailsBase implements Props {
    @Prop({required: true})
    preloadedDetails!: TrainingQualificationDetailsModel;
    @Prop({default: true})
    addContainerCss!: boolean;

    @Prop({default: null})
    editRouteName?: string;

    details: TrainingQualificationDetailsModel = this.preloadedDetails;
    actions: IQualificationActions = factory.create(QualificationActions);

    async created() {
        await this.updateAvailableActions();
    }

    async approve() {
        await new QualificationsClient().approve(this.details.id, this.details.version!);
        this.details = await new QualificationsClient().getTrainingQualification(this.details.id);
        await this.updateAvailableActions();
    }

    async disapprove(comment: string) {
        await new QualificationsClient().disapprove(this.details.id, comment);
        this.details = await new QualificationsClient().getTrainingQualification(this.details.id);
        await this.updateAvailableActions();
    }

    async updateAvailableActions() {
        const qualificationActions = await new QualificationsClient().availableActions(this.details.seafarerId, this.preloadedDetails.id);
        this.actions = {
            ...qualificationActions,
            canApprove: qualificationActions.canApprove && this.details.validity == ValidityStatus.Unchecked,
            canDisapprove: qualificationActions.canDisapprove && this.details.validity != ValidityStatus.Invalid
        }
    }

    async getDownloadUrl(fileId: string): Promise<string> {
        return (await new QualificationsClient().downloadTrainingQualificationFile(this.id, fileId)).url;
    }

    async deleteQualification() {
        await new QualificationsClient()
            .delete(this.preloadedDetails.id)
            .then(async () => {
                toasts.success(this.$ls.Documents_Toast_Success_DocumentDeletion);
            })
        // TODO(KK): Handle errors?
        this.$router.push({name: "seafarer-qualifications", params: {seafarerId: this.details.seafarerId}});
    }

    navigateToEdit(){
        this.$router.push({
            name: this.editRouteName ? this.editRouteName : 'training-edit',
            params: { id: this.preloadedDetails.id, seafarerId: this.details.seafarerId}
        });
    }
}
